module.exports = __webpack_public_path__ + "static/media/help_studies.2b21640f.svg";